import React from 'react';

type DataRow = {
  label: string;
  value: string | number | React.ReactNode;
  valueClassName?: string;
};

type TProps = {
  data: DataRow[];
  labelClassName?: string;
  containerClassName?: string;
  rowClassName?: string;
};

/**
 * BasicTwoColumnData - A reusable component for displaying label-value pairs in two columns
 * 
 * @param data - Array of objects with label and value
 * @param labelClassName - Optional CSS classes for labels
 * @param containerClassName - Optional CSS classes for the container
 * @param rowClassName - Optional CSS classes for each row
 * 
 * @example
 * <BasicTwoColumnData 
 *   data={[
 *     { label: 'Name', value: 'John Doe' },
 *     { label: 'Email', value: 'john@example.com' },
 *     { label: 'Status', value: 'Active' }
 *   ]}
 * />
 */
export default function BasicTwoColumnData({
  data,
  labelClassName = 'font-semibold text-gray-700 dark:text-gray-300',
  containerClassName = '',
  rowClassName = 'py-2',
}: TProps) {
  return (
    <div className={containerClassName}>
      {data.map((row, index) => (
        <div
          key={index}
          className={`grid grid-cols-[auto_1fr] gap-4 md:gap-8 ${rowClassName}`}
        >
          <div className={`text-left ${labelClassName}`}>
            {row.label}:
          </div>
          <div className={`text-left ${row.valueClassName || ''}`}>
            {row.value}
          </div>
        </div>
      ))}
    </div>
  );
}
